import script from "./MetricTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricTable.vue?vue&type=script&setup=true&lang=js"

import "./MetricTable.vue?vue&type=style&index=0&id=0f2a7c00&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f2a7c00"]])

export default __exports__